import { Navigate } from 'react-router-dom';
// 导入需要配置路由的组件
import Home from "../pages/Home";
import Post from "../pages/Post";

// 路由配置选项效果然后挂载到对应的节点即可
const routes =  [
    {
        path: "/",
        component: <Home />,
        exact: false,
    },
    {
        path: "/home",
        component: <Navigate to ='/' />,
        exact: false,
    },
    {
        path: "/post/:id",
        component: <Post />,
        exact: false,
    },
    {
        path: "/post/:id/:type",
        component: <Post />,
        exact: false,
    }
]
export default routes;